import { useCurrentShiftCardMenu } from '~/components/shared/useCurrentShiftCardMenu';
import { getProfessionalName } from '~/utils/professional';
import { type ITodayJob, mapTodayJobToShiftCard } from './mapTodayJobToShiftCard';

/**
 * Drives a "Today's Professionals" card: maps the raw job to the block props and wires the
 * shared current-shift actions (Chat / Rebook / Add-to-Favorite + the warning-icon report
 * flow) via `useCurrentShiftCardMenu`. Rebook is offered only for shifts (not interviews)
 * with an assigned professional. Keeps the card presentational.
 */
export const useTodayShiftCard = (job: ITodayJob) => {
  const cardData = mapTodayJobToShiftCard(job);

  const isInterview = Boolean(job?.isOnsiteInterview);
  const professional = job?.professional;
  const professionalId = professional?._id;
  const professionalName = getProfessionalName(professional);
  const profession = job?.profession;
  const jobId = job?.id || job?._id;
  const jobIdStr = jobId ? String(jobId) : '';

  const { menuItems, rebookPopup, onReportIncident, incidentReported, canReportIncident } =
    useCurrentShiftCardMenu({
      jobId: jobIdStr,
      shiftStart: job?.shift?.start,
      professionalId,
      professionalName,
      alreadyReported: Boolean(job?.incident),
      rebook:
        !isInterview && professionalId
          ? {
              user: {
                id: professionalId,
                name: professionalName ?? '',
                image: professional?.image,
                profession,
                professions: profession ? [profession] : [],
                officeId: job?.offer_owner?._id,
              },
              shiftId: jobIdStr || undefined,
              source: 'dashboard',
            }
          : undefined,
    });

  return {
    cardData,
    menuItems,
    rebookPopup,
    onReportIncident,
    incidentReported,
    canReportIncident,
  };
};
